/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Surface_AuthInputs */

const en_marketing_surface_auth = /** @type {(inputs: Marketing_Surface_AuthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auth`)
};

const es_marketing_surface_auth = /** @type {(inputs: Marketing_Surface_AuthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autenticación`)
};

const fr_marketing_surface_auth = /** @type {(inputs: Marketing_Surface_AuthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authentification`)
};

/**
* | output |
* | --- |
* | "Auth" |
*
* @param {Marketing_Surface_AuthInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_surface_auth = /** @type {((inputs?: Marketing_Surface_AuthInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Surface_AuthInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_surface_auth(inputs)
	if (locale === "es") return es_marketing_surface_auth(inputs)
	return fr_marketing_surface_auth(inputs)
});